(function () {
  const overlay = document.getElementById('upsell-popup-overlay');
  if (!overlay) return;

  const popup = overlay.querySelector('.upsell-popup');
  const closeBtn = document.getElementById('upsell-popup-close');
  const qtyTitleEl = document.getElementById('upsell-popup-qty-title');

  const productTitle = overlay.dataset.productTitle || '';
  const productId = overlay.dataset.productId || '';

  let isOpen = false;

  function openPopup(qty, title) {
    if (qtyTitleEl) {
      qtyTitleEl.textContent = qty + 'x ' + title;
    }
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    isOpen = true;
    document.body.style.overflow = 'hidden';
    closeBtn && closeBtn.focus();
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    isOpen = false;
    document.body.style.overflow = '';
  }

  closeBtn && closeBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (isOpen && e.key === 'Escape') closePopup();
  });

  // Listen for successful cart add
  document.addEventListener('cart:update', function (e) {
    const detail = e.detail || {};
    const data = detail.data || {};

    if (data.didError) return;
    if (data.source !== 'product-form-component') return;

    // Only trigger on this product page (match by productId when available)
    if (data.productId && data.productId !== productId) return;

    const qty = data.itemCount || 1;
    openPopup(qty, productTitle);
  });

  // Add upsell products to cart from popup
  overlay.addEventListener('click', function (e) {
    const btn = e.target.closest('.upsell-popup__item-btn');
    if (!btn || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          btn.disabled = false;
          return;
        }

        btn.classList.add('is-added');
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

        // Update cart icon count
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: { source: 'upsell-popup', itemCount: cart.item_count },
              },
            }));
          })
          .catch(function () {});
      })
      .catch(function () {
        btn.disabled = false;
      });
  });
})();
